import { Component, createRef } from "react";
import BlockScroller from "../BlockScroller";
import BlockHead from "../_BlockHead";
import ErrorBlock from "../ErrorBlock";
import { CAjaxPoll } from "./ajax_poll";
import { IBlockComponentProps } from "../_Block";
import { AppContextType } from "../../../../stores/StoreLoader";
import { isJson } from "../../../admin/spinup/utilities";
import styles from "./styles/PollBlock.module.scss";
import { getConfig } from "../../../../_configs/AppConfig";
import { StoreContext } from "../../../../stores/StoreContext";
import { Box, Button, Flex, Grid, Radio } from "@radix-ui/themes";

interface IPollBlockProps extends IBlockComponentProps {
  blockObj: IPollBlockObj;
}

class PollForm extends Component<
  {
    question: string;
    tid: string;
    answers: string[];
    blockObj: IPollBlockObj;
  },
  { loading: boolean }
> {
  private ajax_poll;
  private blockRef;

  static contextType = StoreContext;

  constructor(props) {
    super(props);

    this.blockRef = createRef();

    this.state = {
      loading: false,
    };
  }

  setLoading = (value: boolean) => {
    this.setState({
      loading: value,
    });
  };

  componentDidMount() {
    import("jquery").then((module) => {
      // @ts-ignore
      window.jQuery = module.default;
      // @ts-ignore
      window.$ = module.default;

      import("blockui/jquery.blockUI").then(() => {
        this.ajax_poll = new CAjaxPoll(this.blockRef.current, this.setLoading);
        this.ajax_poll.run();
      });
    });
  }

  render() {
    try {
      const { userStore, organizationStore } = this.context as AppContextType;
      const blockObj = this.props.blockObj;
      const { publicRuntimeConfig } = getConfig();

      const commandurl = `${publicRuntimeConfig.API_SPEC_URL.replace(/\/?schema-oas\.json$/, "")}/organizations/${organizationStore.currentOrganization.id}/blocks/${blockObj.id}/block_command/`;

      return (
        <>
          {this.state.loading && <div className={styles.loading} />}
          <form
            ref={this.blockRef}
            className="ajax-poll-form"
            data-tid={this.props.tid}
            data-userid={userStore.id}
            action={commandurl}
          >
            <fieldset>
              <legend className="sr-only">{this.props.question}</legend>
              <Box pb="4">
                <Flex direction="column" gap="2">
                  {this.props.answers &&
                    this.props.answers.map((answer, key) => {
                      return (
                        <div
                          key={key}
                          className="ajax-poll-item"
                          data-tid={key}
                        >
                          <Flex align="center" gap="2">
                            {/*@ts-ignore*/}
                            <Radio
                              title="Poll answer"
                              className="ajax-poll-item-radio"
                              name={"_"}
                              id={`answer_${key}${blockObj.id}`}
                            />
                            <label
                              aria-labelledby={`answer_${key}${blockObj.id}`}
                            >
                              {answer}
                            </label>
                          </Flex>
                          <div className="ajax-poll-item-stats-box">
                            <div className="ajax-poll-item-bar" />
                            <span className="ajax-poll-item-count" />
                            <span className="ajax-poll-item-perc" />
                          </div>
                        </div>
                      );
                    })}
                </Flex>
              </Box>
              <div className="text-center ajax-poll-vote-box">
                <Flex gapX={"2"} justify={"center"}>
                  <Button
                    variant="ghost"
                    className="ajax-poll-btn-view sb-organization-color-element-bg"
                  >
                    View
                  </Button>
                  {userStore.id && (
                    <>
                      <Button
                        variant="ghost"
                        className="ajax-poll-btn-vote sb-organization-color-element-bg"
                      >
                        Vote
                      </Button>
                      <br />
                    </>
                  )}
                </Flex>
              </div>

              <div className="ajax-poll-back-box" style={{ display: "none" }}>
                <Grid columns="2" gap="4">
                  <Button
                    variant="ghost"
                    className="ajax-poll-btn-back sb-organization-color-element-bg"
                  >
                    {"< Back "}
                  </Button>
                  <div className="ajax-poll-total-box">
                    <span className="ajax-poll-total-caption">Total:</span>
                    <span className="ajax-poll-total-value" />
                  </div>
                </Grid>
              </div>
            </fieldset>
          </form>
        </>
      );
    } catch (_e: unknown) {
      const e: Error = _e as Error;
      return <ErrorBlock blockObj={{ errorMessage: e }} />;
    }
  }
}

export default function PollBlock(props: IPollBlockProps) {
  try {
    const blockObj = props.blockObj;

    let json_data = props.blockObj?.blockModel?.jsonObj
      ? props.blockObj.blockModel.jsonObj
      : props.blockObj.blockModel?.json_data;
    if (typeof json_data === "string" && isJson(json_data))
      json_data = JSON.parse(json_data);
    const question = json_data?.block?.settings?.question || "";
    const answers = json_data?.block?.settings?.answers || [];
    const tid = `${blockObj.title}_${question}_${answers.join("")}`;

    return (
      <BlockScroller
        className="sb-block-poll"
        blockRef={props.blockRef}
        blockObj={props.blockObj}
        setShowExpandButton={props.setShowExpandButton}
        outsideGrid={props.outsideGrid}
      >
        <BlockHead
          className="sb-block-poll"
          blockType={blockObj.blockType}
          editableTitle={question}
          blockId={blockObj.id}
          isBlockPreview={props.isBlockPreview}
        />
        <div className={`sb-blockContent scroll-${tid}`}>
          <PollForm
            {...props}
            question={question}
            answers={answers}
            tid={tid}
          />
        </div>
      </BlockScroller>
    );
  } catch (_e: unknown) {
    const e: Error = _e as Error;
    return <ErrorBlock blockObj={{ errorMessage: e }} />;
  }
}
